var _metadata, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    viewBox: "0 0 64 64",
    id: "svg5890",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5894"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5883"
  }, /*#__PURE__*/React.createElement("filter", {
    x: "-23.9%",
    y: "-17.9%",
    width: "147.8%",
    height: "135.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset5870"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    id: "feGaussianBlur5872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098039   0 0 0 0 0.149019608   0 0 0 0 0.164705882  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    id: "feColorMatrix5874"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "feMerge5880"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1",
    id: "feMergeNode5876"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic",
    id: "feMergeNode5878"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(3,0,0,3,-63.734836,-64.499859)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-135,-352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ovladani",
    transform: "translate(144,344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-copy",
    transform: "translate(3,20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.375,19.25 H 20.75 V 11 c 0,-0.41475 -0.336,-0.75 -0.75,-0.75 -0.414,0 -0.75,0.33525 -0.75,0.75 v 8.25 h -8.625 c -0.414,0 -0.75,0.33525 -0.75,0.75 0,0.41475 0.336,0.75 0.75,0.75 h 8.625 v 9 c 0,0.41475 0.336,0.75 0.75,0.75 0.414,0 0.75,-0.33525 0.75,-0.75 v -9 h 8.625 c 0.414,0 0.75,-0.33525 0.75,-0.75 0,-0.41475 -0.336,-0.75 -0.75,-0.75 z",
    id: "delete",
    transform: "rotate(-45,20,20.375)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.e0bf33a760b6921937155d54b3617d2b.svg";
export { ForwardRef as ReactComponent };